import React from "react";
import LiqMapPage from "../components/liqmap/LiqMapPage";

// Route page wrapper — kept thin so the orchestrator stays self-contained.
export default function LiquidityMapPage() {
  return <LiqMapPage />;
}
